import React from 'react';
import { Box, Flex, ScaleFade } from '@chakra-ui/react';

import { HeaderUp } from '../../../components/_components_0.2/Header_0.2';
import { Sidebar } from '../../../components/_components_0.2/Sidebar_0.2';
import { MobileNav } from './MobileNav';

/**
 * Wrapper comum das telas do módulo Controle de Qualidade — mesmo esqueleto
 * (HeaderUp + Sidebar lateral) usado por vehicles_management/Dashboard,
 * reaproveitado aqui para não repetir o boilerplate em cada página.
 */
export const PageShell: React.FC = ({ children }) => (
  <ScaleFade initialScale={0.95} in>
    <Flex direction="column" minH="100vh">
      <HeaderUp path="quality" />
      <Flex
        w="100%"
        my={{ base: '4', md: '6' }}
        maxWidth={1480}
        mx="auto"
        pb={8}
        px={{ base: '4', md: '6' }}
      >
        <Sidebar path="quality" />
        <Box flex="1" minW={{ base: '0', md: 'auto' }}>
          <MobileNav />
          {children}
        </Box>
      </Flex>
    </Flex>
  </ScaleFade>
);
